import { openModal } from '@core/components/ModalStack';
import { SelectProposalModalProps } from './SelectProposalModal';

export async function openSelectProposalModal(props: SelectProposalModalProps) {
  const { SelectProposalModal } = await import('./SelectProposalModal');

  openModal(SelectProposalModal, props);
}
